import React, { useEffect, useState, useRef } from "react";
import {
  Heading,
  Flex,
  Avatar,
  Button,
  Image,
  Box,
  Text,
  Divider,
  Center,
  Container, Spinner
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";

import Layout from "@pages/Layout";
import { Separator, View, PersonDetailsAttr, PreviewPdf, ModalBox } from "@components";
import { IconStar, IconViewCV, IconVideo, IconSuccess } from "@assets/Icons";
import { loadCandidateCV } from "@lib/datahandlers/company";
import { unlike_candidate, like_candidate } from "@lib/datahandlers/company";
import { t } from "@lang/i18n";

const videoStyle = {
  minWidth: "100%",
  height: "100%",
};

const ConfirmBox = ({ showModalBox, setShowModalBox }) => {
  return(
      <View if={showModalBox}>
          <ModalBox isOpen={showModalBox}>
              <View mb="30px">
                  <IconSuccess iconType="candidate" />
              </View>
              <Text color="black" textAlign="center" fontSize="20px" fontWeight="600">
                  {t("messages.popup.no_cv")}
              </Text>

              <Button bg="white" border="2px solid" borderRadius="24px" color="green.dark" borderColor="green.dark" w="150px" h="40px" mt="26px"
                      _hover={{ bg: "white", opacity: ".7" }} 
                      onClick={() => setShowModalBox(false)}
                  >
                  {t("global.close")}
              </Button>
          </ModalBox>
      </View>
  )
}

const PersonDetails = () => {
  const [cv, setCV] = useState({});
  const [play, setPlay] = useState(false);
  const [favourite, setFavourite] = useState(false);
  const [showPDF, setShowPDF] = useState(false);
  const [showModalBox, setShowModalBox] = useState(false);

  // get user id
  const { id } = useParams();
  // reference video tag
  const videoRef = useRef();

  // handle star
  const handleStar = (id) => {
    setFavourite(!favourite);
    const person_id = parseInt(id);
    favourite ? onUnlike(person_id) : onLike(person_id);
  };
  // error Video
  const errorVideo = () => {
    console.log('an error occured while loading the video !')
  };
  // check if obj is empty
  const isObjectEmpty = (obj) => {
    if (Object.entries(obj).length === 0) return true;
    return false;
  };
  // hnalde display cv
  const displayCV = () => {
    cv.CV ? setShowPDF(true) : setShowModalBox(true)
  };

  // load corresponding user data
  const onLoad = async (id) => {
    try {
      const result = await loadCandidateCV(id);
      if (result.success) {
        const { address, person, email, picture, phone, liked } = result.data;

        setCV({
          address,
          search_radius: person.search_radius + "Km",
          situation: person.situation && person.situation.name,
          fonctions: person.fonctions.length > 0 && person.fonctions.map(el => el.name).join(', '),
          experience: person.experience && person.experience.name,
          activities: person.activities.length > 0 && person.activities.map(el => el.name).join(', '),
          phone,
          email,
          relationship_status: person.relationship_status && person.relationship_status.name,
          driving_license: person.driving_license,
          has_vehicle: person.has_vehicle,
          has_handicap: person.has_handicap,
          full_name: person.first_name + " " + person.last_name,
          full_birthdate: person.birthday ? person.birthday + " " + "(" + person.age + " ans)": null,
          CV: person.CV,
          picture: picture,
          video: person.video,
          thumbnail: person.thumbnail,
          liked,
          id: person.id,
        });
        setFavourite(liked === 1 ? true : false)
        return;
      }
    } catch (err) {
      console.log(err);
    }
  };
  // like candidate
  const onLike = async (id) => {
    try {
      const result = await like_candidate({ person_id: id });
      if (result.success) return;
    } catch (err) {
      console.log("Error: ", err);
    }
  };
  // unlike candidate
  const onUnlike = async (id) => {
    try {
      const result = await unlike_candidate({ person_id: id });
      if (result.success) return;
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  // load candidate cv
  useEffect(() => {
    if (isObjectEmpty(cv)) {
      onLoad(id);
    }
  }, []);

  // match play button with video play
  useEffect(() => {
    if (play) videoRef.current.play();
  }, [play]);

  return (
    <Layout menuType="company" isNavBarVisible isFooterVisible>
      <Container maxW="1024px" bg="white" minHeight='calc(100vh - 100px)' py="36px" px={["16px", "", "", "100px"]} borderRadius="4px">
        <Flex flexDir="column">
          <Heading as="h1" fontSize="30px" color="black" textAlign="center">
            {t("company.candidate_cv.title")}
          </Heading>

          <Separator />

          <Flex flexDir="row" flexWrap="wrap-reverse" justifyContent="space-around" alignItems="center">
            <Flex w="348px" h="619px" borderColor="#979797" borderRadius="3px" flexDir="column" justifyContent="center" alignItems="center"
              border={!cv.video && "1px solid"}
              >
              {/* Video */}
              <View if={play && cv.video} pos="relative">
                <video style={videoStyle} 
                      onEnded={() => setPlay(false)} 
                      onError={() => errorVideo()}
                      controls={play} ref={videoRef}>
                  <source src={cv.video} type="video/mp4" />
                </video>
              </View>

              <View if={!play && cv.video} pos="relative">             
                <Image src={cv.thumbnail} alt="thumbnail" />
                <Box pos="absolute" top="40%" left="36%" zIndex="100"
                  _hover={{ cursor: "pointer" }}
                  onClick={() => setPlay(true)}
                >
                  <IconVideo iconAction="play" iconType="company" />
                </Box>
              </View>

              <View if={!cv.video}>
                <Flex flexDir="column" mr="16px" w="249px">
                  <Box mx="auto" mb="20px" _hover={{ cursor: "pointer" }}>
                    <IconVideo iconAction="none" />
                  </Box>
                  <Text fonctSize="14px" fontWeight="700" textAlign="center" color="gray.borderBoxes">
                    {t("company.candidate_cv.video_none")}
                  </Text>
                </Flex>
              </View>
            </Flex>

            <Center height="30rem" m="78px 0" display={["none", "", "block"]}>
              <Divider orientation="vertical" borderLeft=".5px solid #888" h="30rem" />
            </Center>

            <Flex flexDir="column" ml="16px" mb="2rem">
              <Flex flexDir={["column", "row"]} alignItems="center" justifyContent="space-between">
                <Avatar src={cv.picture ? cv.picture : ""} name="avatar" size="xl" my={[".5rem", "", "", ""]} />
                <Text color="black" fontWeight="700" fontSize="20px" w="180px" textAlign="center" my={[".5rem", "", "", ""]}>
                  {cv.full_name}
                </Text>
                <Box _hover={{ cursor: "pointer" }} my={[".5rem", "", "", ""]}>
                  <IconStar iconType="company" variant={favourite ? "filled" : "outline"} event={() => handleStar(cv.id)}/>
                </Box>
              </Flex>

              <Flex flexDir="column" mt="32px" mb="54px"> 
                <PersonDetailsAttr FieldName={t("fields.company.birth_date")} data={cv.full_birthdate ? cv.full_birthdate : "---"} />
                <PersonDetailsAttr FieldName={t("fields.company.address")} data={cv.address} />
                <PersonDetailsAttr FieldName={t("fields.company.rayon_search")} data={cv.search_radius} />
                <PersonDetailsAttr FieldName={t("fields.company.situation")} data={cv.situation ? cv.situation : "---"} />
                <PersonDetailsAttr FieldName={t("fields.company.metier")} data={cv.fonctions} />
                <PersonDetailsAttr FieldName={t("fields.candidates.activities")} data={cv.activities ? cv.activities : "---"} />
                <PersonDetailsAttr FieldName={t("fields.company.experience")} data={cv.experience} /> 
                <PersonDetailsAttr FieldName={t("fields.company.phone")} data={cv.phone} /> 
                <PersonDetailsAttr FieldName={t("fields.email")} data={cv.email} /> 
                <PersonDetailsAttr FieldName={t("fields.company.civil_status")} 
                    data={ cv.relationship_status === 1 ? t("global.yes") : cv.relationship_status === 0 ? t("global.no") : "---" } 
                /> 
                <PersonDetailsAttr FieldName={t("fields.company.has_permis")} 
                  data={ cv.driving_license === 1 ? t("global.yes") : cv.driving_license === 0 ? t("global.no") : "---" }
                /> 
                <PersonDetailsAttr FieldName={t("fields.company.has_vehicule")} 
                    data={ cv.has_vehicle === 1 ? t("global.yes") : cv.has_vehicle === 0 ? t("global.no") : "---" }
                />
                <PersonDetailsAttr FieldName={t("fields.company.handicap")} 
                    data={ cv.has_handicap === 1 ? t("global.yes") : cv.has_handicap === 0 ? t("global.no") : "---" } 
                /> 
              </Flex>

              <View if={!cv.CV}>
                <Button rightIcon={<IconViewCV />} 
                  display="flex" mx="auto" w={{base: "60vw", md: "344px"}} h="40px" color="white" borderRadius="5px" bg="green.main" boxShadow="0px 1px 3px rgba(129, 129, 129, 0.5)"
                  _hover={{ bg: "green.light", cursor: "pointer" }}
                  onClick={() => setShowModalBox(true)}
                >
                  {t("company.candidate_cv.check_cv")}
                </Button>
              </View>
                
              <View if={cv.CV}>
                <Button rightIcon={<IconViewCV />} onClick={() => displayCV()}
                    display="flex" mx="auto" w={{base: "60vw", md: "344px"}} h="40px" color="white" borderRadius="5px" bg="green.main" boxShadow="0px 1px 3px rgba(129, 129, 129, 0.5)"
                    _hover={{ bg: "green.light", cursor: "pointer" }}
                  >
                    {showPDF? <Spinner size="md" /> : t("company.candidate_cv.check_cv")}
                </Button>
                <PreviewPdf file={cv.CV} showPDF={showPDF} setShowPDF={() => setShowPDF(false)} />
              </View>

              <View if={showModalBox}>
                <ConfirmBox showModalBox={showModalBox} setShowModalBox={setShowModalBox} />
              </View>
            </Flex>
          </Flex>
        </Flex>
      </Container>
    </Layout>
  );
};

export default PersonDetails;
